import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import BuildingMaterialsLogisticsService from "../views/ProjectServices/BuildingMaterialsLogisticsService.vue";
import InternationalFreightForwarder from "../views/ProjectServices/InternationalFreightForwarder.vue";
import InternationalShippingServices from "../views/ProjectServices/InternationalShippingServices.vue";
import CommodityLogisticsServices from "../views/ProjectServices/CommodityLogisticsServices.vue";
import BusinessLogisticsService from "../views/ProjectServices/BusinessLogisticsService.vue";
import AftermarketService from "../views/ProjectServices/AftermarketService.vue";
import GlobalStrategy from "../views/AboutUs/GlobalStrategy.vue";
import LogisticsNetwork from "../views/ProjectServices/LogisticsNetwork.vue";
import CompanyProfile from "../views/AboutUs/CompanyProfile.vue";
import AboutTheFounder from "../views/AboutUs/AboutTheFounder.vue";
import EnterpriseHonor from "../views/AboutUs/EnterpriseHonor.vue";
import DevelopmentCourse from "../views/AboutUs/DevelopmentCourse.vue";
import CooperationAndCommunication from "../views/NewsCenter/CooperationAndCommunication.vue";
import MediaAttention from "../views/NewsCenter/MediaAttention.vue";
import StaffPresence from "../views/NewsCenter/StaffPresence.vue";
import NewsCenterDetail from "../views/NewsCenter/Detail.vue";
import CollegeIsIntroduced from "../views/CultivationOfTalents/CollegeIsIntroduced.vue";
import EmployeeTraining from "../views/CultivationOfTalents/EmployeeTraining.vue";
import StaffTraining from "../views/CultivationOfTalents/StaffTraining.vue";
import CultivationOfTalentsDetail from "../views/CultivationOfTalents/Detail.vue"
import ContactInformation from "../views/ContactUs/ContactInformation.vue";
import JoinUs from "../views/ContactUs/JoinUs.vue";
import JoinUsDetail from "../views/ContactUs/JoinUsDetail.vue";
import CorporateCultures from "../views/Culture/CorporateCultures.vue";
import Departments from "../views/Culture/Departments.vue";
import GroupWedding from "../views/Culture/GroupWedding.vue";
import MrsMetting from "../views/Culture/MrsMetting.vue";
import RedTrain from "../views/Culture/RedTrain.vue";
import CultureDetail from "../views/Culture/Detail.vue";
import EmployeeTrainingSingle from "@/views/CultivationOfTalents/EmployeeTrainingSingle";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Index",
        component: Index
    },
    {
        path: "/contentPage",
        name: "ContentPage",
         component: () => import('@/views/Template/TemplatePage.vue')
    },
    {
        path: "/honorPage",
        name: "Honor",
         component: () => import('@/views/Template/Honor.vue')
    },
    {
        path: "/newsPage",
        name: "News",
         component: () => import('@/views/Template/News.vue')
    },
    {
        path: "/newsDetailPage",
        name: "NewsDetail",
         component: () => import('@/views/Template/NewsDetail.vue')
    },
    // projectServices
    {
        path: "/projectServices/logisticsNetwork",
        name: "LogisticsNetwork",
        component: LogisticsNetwork
    },
    {
        path: "/projectServices/buildingMaterialsLogisticsService",
        name: "BuildingMaterialsLogisticsService",
        component: BuildingMaterialsLogisticsService
    },
    {
        path: "/projectServices/internationalShippingServices",
        name: "InternationalShippingServices",
        component: InternationalShippingServices
    },
    {
        path: "/projectServices/commodityLogisticsServices",
        name: "CommodityLogisticsServices",
        component: CommodityLogisticsServices
    },
    {
        path: "/projectServices/internationalFreightForwarder",
        name: "InternationalFreightForwarder",
        component: InternationalFreightForwarder
    },
    {
        path: "/projectServices/businessLogisticsService",
        name: "BusinessLogisticsService",
        component: BusinessLogisticsService
    },
    {
        path: "/projectServices/aftermarketService",
        name: "AftermarketService",
        component: AftermarketService
    },
    {
        path: "/about/globalStrategy",
        name: "GlobalStrategy",
        component: GlobalStrategy
    },
    // about
    {
        path: "/about/companyProfile",
        name: "CompanyProfile",
        component: CompanyProfile
    },
    {
        path: "/about/aboutTheFounder",
        name: "AboutTheFounder",
        component: AboutTheFounder
    },
    {
        path: "/about/enterpriseHonor",
        name: "EnterpriseHonor",
        component: EnterpriseHonor
    },
    {
        path: "/about/developmentCourse",
        name: "DevelopmentCourse",
        component: DevelopmentCourse
    },
    // newsCenter
    {
        path: "/newsCenter/coperationAndCommunication",
        name: "CooperationAndCommunication",
        component: CooperationAndCommunication
    },
    {
        path: "/newsCenter/mediaAttention",
        name: "MediaAttention",
        component: MediaAttention
    },
    {
        path: "/newsCenter/staffPresence",
        name: "StaffPresence",
        component: StaffPresence
    },
    // cultivationOfTalentsTop
    {
        path: "/cultivationOfTalentsTop/collegeIsIntroduced",
        name: "CollegeIsIntroduced",
        component: CollegeIsIntroduced
    },
    {
        path: "/cultivationOfTalentsTop/employeeTraining",
        name: "EmployeeTraining",
        component: EmployeeTraining
    },
    {
        path: "/cultivationOfTalentsTop/EmployeeTrainingSingle",
        name: "EmployeeTrainingSingle",
        component: EmployeeTrainingSingle
    },
    {
        path: "/cultivationOfTalentsTop/staffTraining",
        name: "StaffTraining",
        component: StaffTraining
    },
    // contactUs
    {
        path: "/contactUs/contactInformation",
        name: "ContactInformation",
        component: ContactInformation
    },
    {
        path: "/contactUs/joinUs",
        name: "JoinUs",
        component: JoinUs
    },
    // culture
    {
        path: "/culture/corporateCultures",
        name: "CorporateCultures",
        component: CorporateCultures
    },
    {
        path: "/culture/departments",
        name: "Departments",
        component: Departments
    },
    {
        path: "/culture/groupWedding",
        name: "GroupWedding",
        component: GroupWedding
    },
    {
        path: "/culture/mrsMetting",
        name: "MrsMetting",
        component: MrsMetting
    },
    {
        path: "/culture/redTrain",
        name: "RedTrain",
        component: RedTrain
    },
    // detail - contactUs
    {
        path: "/contactUs/joinUs/detail",
        name: "JoinUsDetail",
        component: JoinUsDetail
    },
    // detail - newsCenter
    {
        path: "/newsCenter/detail",
        name: "NewsCenterDetail",
        component: NewsCenterDetail
    },
    // detail - Culture
    {
        path: "/culture/detail",
        name: "CultureDetail",
        component: CultureDetail
    },
    // detail - CultivationOfTalents
    {
        path: "/cultivationOfTalents/detail",
        name: "CultivationOfTalentsDetail",
        component: CultivationOfTalentsDetail
    },
];
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
router.beforeEach((to, from, next)=>{
    // 路由拦截以前的老官网，从百度查询的打开链接
    if(to.path.indexOf(".html") != -1){
        // 从百度搜索过来的页面
        next({
            path: "/",
            name: "Index",
            component: Index
        });
    }else{
        // 本系统开发的页面
        next();
    }
});
export default router;
